// Villes visitées par le Ministère Prophétique Jesus Talk
export const CITIES_MINISTRY = [
  {
    id: "paris",
    city: "Paris",
    region: "Île-de-France",
    country: "France",
    churches: [
      {
        name: "Tous Unis Pour Christ",
        address: "Maison-Alfort",
        service: "Dimanche · 10h – 12h",
        contact: "",
      },
    ],
  },
  {
    id: "marseille",
    city: "Marseille",
    region: "Provence-Alpes-Côte d'Azur",
    country: "France",
    churches: [
      {
        name: "Église Blancarde",
        address: "4 Boulevard Blancarde, Marseille",
        service: "Dimanche · 10h – 12h",
        contact: "",
      },
    ],
  },
];

export const FAQ_ITEMS = [
  {
    q: "Qu'est-ce que Jesus Talk exactement ?",
    a: "Jesus Talk est un média chrétien né d'une vision que Dieu a révélée à Laetitia : ouvrir un espace pour développer sa vie spirituelle et sa relation avec Jésus, à travers des podcasts et d'autres supports de communication. Ce n'est pas d'abord un ministère, c'est un média — une porte d'entrée vers la foi vivante. En parallèle, Prophète Belver porte un ministère prophétique de visite d'église en église.",
  },
  {
    q: "Le contenu est-il gratuit ?",
    a: "Oui, tous nos podcasts, méditations, versets et parcours sont entièrement gratuits. Notre mission est de rendre la Parole accessible à tous.",
  },
  {
    q: "Comment savoir quel parcours de croissance me correspond ?",
    a: "Réponds simplement au quiz d'orientation sur la page d'accueil (6 questions courtes). En moins de 2 minutes, tu recevras la recommandation du parcours qui t'accompagnera le mieux dans ta saison actuelle.",
  },
  {
    q: "Puis-je inviter Jesus Talk dans mon église ?",
    a: "Absolument ! Rends-toi sur la page « Invitation » et remplis le formulaire dédié aux pasteurs et responsables d'église. Nous te répondrons personnellement dans les plus brefs délais.",
  },
  {
    q: "Comment partager un témoignage ?",
    a: "Sur la page « Témoignages », tu trouveras un formulaire pour raconter ta rencontre avec Dieu, ta guérison, ta restauration. Chaque témoignage relu et validé sera publié pour encourager d'autres.",
  },
  {
    q: "Que faire quand je ne ressens plus Dieu ?",
    a: "C'est une saison que beaucoup traversent. La foi n'est pas d'abord une émotion mais une confiance persévérante dans les promesses de Dieu. Le parcours « La Traversée » a été pensé pour t'accompagner concrètement dans ce silence.",
  },
  {
    q: "Comment commencer à prier ?",
    a: "Commence simple : parle à Dieu comme à un Père. 5 minutes par jour dans un endroit calme, en lisant un Psaume et en Lui confiant ta journée. La prière n'est pas une performance, c'est une relation.",
  },
  {
    q: "Puis-je écouter les podcasts sans internet ?",
    a: "Oui, chaque épisode est disponible sur Spotify, Apple Podcasts et Deezer où tu peux le télécharger pour l'écouter hors ligne.",
  },
];
